import http from "./httpService";
import { apiUrl } from "config/envConfig";

const path = "/notification-mgmt/admin/notifications/driver/createannouncement";
const url=apiUrl;

/**
 * Creates a new announcement notification for drivers.
 *
 * @param {Object} payload - The payload containing notification details.
 * @param {string} payload.targetAudience - The target audience (e.g., "all", "approved", etc.).
 * @param {string} payload.notificationTitle - The title of the notification.
 * @param {string} payload.notificationBody - The body/content of the notification.
 *
 * @returns {Promise<Object>} The response data from the server.
 */
export const createDriverAnnouncementNotification = async (payload) => {
  const { data } = await http.post(`${url}${path}`, payload);
  return data;
};
